const trackEventFbq = (event) => {
  if (window.fbq) window.fbq('track', event)
}

export default trackEventFbq
